import { render, staticRenderFns } from "./WhoPage.vue?vue&type=template&id=36465d26&scoped=true&"
import script from "./WhoPage.vue?vue&type=script&lang=js&"
export * from "./WhoPage.vue?vue&type=script&lang=js&"
import style0 from "./WhoPage.vue?vue&type=style&index=0&id=36465d26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36465d26",
  null
  
)

export default component.exports